// CRM B-VII: In der Zuordnungsliste (Mail-Fenster und Aufgaben-Fenster) sagt eine
// Anfragenummer allein wenig. Die Produkte machen die Anfrage erkennbar — dieselbe
// Darstellung wie in der Produktanfragen-Uebersicht: kleine runde Vorschaubilder,
// Titel im Tooltip.
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import ItemImage from "../pages/items/components/ItemImage";

// ponytail: die Abfragen holen `customerRequestItems(limit: 5)`. Kein "+N"-Zaehler,
// dafuer muesste die Gesamtzahl mitgezaehlt werden — nachruesten, wenn jemand sie
// vermisst.
//
// Die Bilder liegen uebereinander wie in der Uebersicht. Das macht `scaleOnHover` in
// ItemImage: es zieht jedes Bild um 33px nach links (und schiebt es per `left` wieder
// zurueck), waehrend `me-3` 16px Vorschub gibt — netto 15px pro Bild bei 32px Breite.
// Die Zahlen haengen damit an der Groesse 32; ein anderer `size` loest den Stapel auf.
const RequestItemImages = ({ request, size = 32 }) => {
  const { t } = useTranslation(["components", "common"]);
  const entries = request?.customerRequestItems?.items || [];
  if (entries.length === 0) return null;

  return (
    <span className="d-inline-flex align-items-center">
      {entries.map((entry, index) => (
        <OverlayTrigger
          key={entry.id || index}
          placement="top"
          overlay={<Tooltip>{entry.title || t("No Title")}</Tooltip>}
        >
          <span>
            <ItemImage
              rounded={true}
              scaleOnHover={true}
              showSpinner={false}
              width={size}
              height={size}
              thumbnailSize="50"
              className="me-3"
              documentId={
                entry.item?.coverImageId || entry.item?.itemsHead?.coverImageId
              }
            />
          </span>
        </OverlayTrigger>
      ))}
    </span>
  );
};

export default RequestItemImages;
